import React, {useRef, useEffect} from 'react';
import GlobalStyles from '../styles';
import { Helmet } from 'react-helmet';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import store from '../store';
import { Provider } from 'react-redux';
import IndicationAndSafetyDrawer from '../components/IndicationAndSafety/IndicationAndSafetyDrawer';
import IndicationAndSafety from '../components/IndicationAndSafety';
import HCPAcknowledgement from '../components/HCPAcknowledgement';
import ScrollLockObserver from '../components/ScrollLockObserver';
import GeneralModal from '../components/ExternalModal';


function DefaultLayout({ children, pageMeta, location, name, icon, iconAlt = '', anchorNavLinks, filterIndicationDrawer, safetyDataOverride, indicationId, className, jobCode, hyptheticNav}) {

    useEffect(() => {
        // const timeoutId = setTimeout(() => {
        //     const modalOverlay = document.querySelector('.onetrust-pc-dark-filter');
        //     const hasAcknowledged = window.sessionStorage.getItem('mrk-hcp--acknowledged-hcp');
        //     if(hasAcknowledged === null || hasAcknowledged !== '1'){
        //         if(modalOverlay){
        //             modalOverlay.style.background = 'none';
        //             modalOverlay.classList.add('testcls');
        //         }
        //     }
        //     console.log("hasth===", hasAcknowledged)
        //   }, 650);  
        //     return () => clearTimeout(timeoutId);

        const updateCPRAOverlayStyle = () => {
            const normalOverlay = document.querySelector("[class^='HCPAcknowledgement__ModalOverlay']");
            const cpraOverlay = document.querySelector("#onetrust-consent-sdk .onetrust-pc-dark-filter");
     
            if (cpraOverlay) {
              cpraOverlay.style.setProperty(
                  "background-color",
                  normalOverlay ? "rgba(41, 27, 54, 0)" : "rgba(0, 0, 0, 0.7)",
                  "important"
                );
            }
          };
     
          // Initial check
          updateCPRAOverlayStyle();
     
          // Observe DOM changes
          const observer = new MutationObserver(updateCPRAOverlayStyle);
          observer.observe(document.body, { childList: true, subtree: true });
     
          return () => observer.disconnect();
      }, []);

      const isChatOpen = () => {
          const host = document.querySelector('#webchatv4');
          if (host && host.shadowRoot) {
              const container = host.shadowRoot.querySelector('#ostro-widget-container');
              if (container) {
                  const style = getComputedStyle(container);
                  return style.display !== 'none' && style.visibility !== 'hidden';
              }
          }
          return false;
      };

      useEffect(() => {
          const handleClick = (e) => {
              const target = e.target;
              if (target.tagName === 'A' || target.tagName === 'BUTTON' || target.closest('a') || target.closest('button')) {
                  if (isChatOpen()) {
                      if (window.TAIlor) {
                          window.TAIlor.toggleOpen(false);
                      }
                  }
              }
          };

          document.addEventListener('click', handleClick);

          return () => document.removeEventListener('click', handleClick);
      }, []);

    let launch_button_container_ref = useRef(null);
    let hcp_acknowledgement_ref = useRef(null);
    let inline_indications_ref = useRef(null);
    let general_modal_ref = useRef(null);
    
    return (
        <>
            <Helmet
                htmlAttributes={{
                    lang: 'en',
                }}
            >
                <meta charSet="utf-8" />
                <title>{pageMeta ? pageMeta.title : ''}</title>
                <meta name="description" content={pageMeta ? pageMeta.description : ''} />
                <meta name="keywords" content={pageMeta ? pageMeta.keywords : ''} />
                <link rel="canonical" href={`https://www.keytrudalenvimahcp.com${location ? location.pathname : ''}`} />
                { pageMeta && pageMeta.noindex && (
                    <meta name="robots" content="noindex" />
                )}
                {/* Google Tag Manager */}
                <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','GTM-K3ZXNLB');`}</script>
                {/* End Google Tag Manager */}

                {/* OneTrust Cookies Consent  */}
                {/* <script
                    src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
                    type="text/javascript"
                    charset="UTF-8"
                    data-domain-script={
                        process.env.GATSBY_PRODUCTION_BUILD
                            ? 'bd1318f1-a02b-4bce-98f7-d08eaf90d3da'
                            : '0190d919-2515-7af8-89aa-e7daa5a48033-test'
                    }
                ></script>
                <script type="text/javascript">{`function OptanonWrapper() { }`}</script> */}
                <script
                    src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
                    type="text/javascript"
                    charset="UTF-8"
                    data-domain-script={
                        process.env.GATSBY_PRODUCTION_BUILD
                            ? 'bd1318f1-a02b-4bce-98f7-d08eaf90d3da'
                            : '01941ca7-e944-7cab-ac39-c35f7651761c-test'
                    }
                ></script>
                <script type="text/javascript">{`function OptanonWrapper() { }`}</script>
                {/* OneTrust Cookies Consent end */}
                <script id= "ostro" type= "module" src= "https://static.ostroapi.com/ostro/ostro.js?id=dc31f33d-893e-4760-baad-a506cc6bcd63"></script>
                {/* dataLayer initialization for properly capturing page url on entry */}
                <script type="text/javascript">{`
                    window.dataLayer = window.dataLayer || []; 
                    window.dataLayer.push({
                        event: "initial_page_load",
                        page_url: window.location.href.replace(window.location.origin, '')
                    });
                `}</script>
                {/* end dataLayer initialization for properly capturing page url on entry */}
                {/* begin JSON-LD page info */}
                {/* Becuase Gatsby + Helmet are like helicopter parents, we can't just plop the 
                all the schema tags in one chunk. So we have to do it in this ugly way  */}
                {pageMeta && pageMeta.schemaJsonLD && pageMeta.schemaJsonLD.map(script => <script type="application/ld+json">{script}</script>)}                
                {/* begin JSON-LD */}
            </Helmet>
            {/* Keep global styles outside the Provider, they should never re-render */}
            <GlobalStyles />
            <Provider store={store}>
                <div className={className}>
                    <ScrollLockObserver />
                    <NavBar hyptheticNav={hyptheticNav} location={location} name={name} anchorNavLinks={anchorNavLinks} icon={icon} iconAlt={iconAlt}/>

                    <main>{children}</main>

                    <IndicationAndSafety inline_indications_ref={inline_indications_ref} indicationId={indicationId} safetyDataOverride={safetyDataOverride}/>

                    <Footer jobCode={jobCode}/>

                    <HCPAcknowledgement hcp_acknowledgement_ref={hcp_acknowledgement_ref} />
                    <GeneralModal general_modal_ref={general_modal_ref} />
                    <IndicationAndSafetyDrawer
                        inline_indications_ref={inline_indications_ref}
                        launch_button_container_ref={launch_button_container_ref}
                        hcp_acknowledgement_ref={hcp_acknowledgement_ref}
                        indicationId={filterIndicationDrawer ? indicationId : undefined}
                    />
                </div>
            </Provider>


        </>
    );
}

export default DefaultLayout;